<template>
	<div>
		<el-carousel :interval="2000" arrow="always">
			<el-carousel-item v-for="(item,index) in rotationImgList" :key="index">
				<div>
					<img :src="item.url" style="width: 100%;" />
				</div>
			</el-carousel-item>
		</el-carousel>



		<div>
			<titlecom :title="title"></titlecom>

			<div style="margin-left: 20px;">
				<p class="text">
					由中华医学会、中华医学会细菌感染与耐药防治分会主办，复旦大学附属华山医院抗生素研究所协办的“中华医学会第一次细菌真菌感染学术会议”定于2021年4月8～10日在上海跨国采购会展中心召开。</p>
				<p class="text">
					由细菌、真菌病原微生物引起的感染性疾病为临床常见病、多发病，分布于临床
					各科。抗菌药过度使用，细菌耐药性上升迅速，细菌耐药性已成为严峻的全球性问
					题，耐药菌感染严重危害人类健康，影响社会、经济发展；随着临床各类免疫缺陷患
					者的增多，近年来真菌感染呈上升趋势。应对耐药细菌及真菌感染，需要多学科密切
					协作，需要高端的学术平台。在中华医学会的大力支持与相关领域专家的呼吁下，中
					华医学会细菌感染与耐药防治分会于2020年1月成立，该分会汇聚了国内感染、重
					症、呼吸、血液、临床微生物、临床药理、临床药学和院感防控等多学科专家，致力
					于提高我国细菌、真菌感染诊治和抗菌药物合理应用水平。
				</p>
				<p class="text">
					此会议是依托于中华医学会建立的一个全新的细菌、真菌感染诊治的多学科交流平台，学术内容涉及面广，从基础到临床、从理论到实践，重点聚焦当今细菌真菌感染热点话题，具体内容包括：病原微生物诊断，细菌耐药性监测及耐药机制研究，抗感染药物药效学、临床药理学研究，细菌、真菌感染的诊断与治疗，抗菌药物合理应用与管理，医院感染防控。
				</p>

				<p class="text">
					大会采取线下、线上相结合交流方式。诚挚欢迎感染病诊治相关的临床各科医师和从事临床微生物学、医院感染防控、临床药学、抗感染药临床药理学、抗菌药物管理、新药研发的专业人员参加本次大会
				</p>

				<p class="title">会议时间</p>
				<p class="text">2021年4月8日报到，9、10全天学术会议</p>

				<p class="title">线下会议地点：</p>
				<p class="text">
					上海跨国采购会展中心召开（上海市普陀区光复西路2739号）。
				</p>
			</div>

			<titlecom :title="dynamic"></titlecom>
			<!-- <a style="text-decoration: none;" href="https://mp.weixin.qq.com/s/2GW2Puh-JPEGYMn25fXHpA" target="_blank">
        <P class="huiyi">会议通知</P>
      </a> -->


			<a style="text-decoration: none;"
				href="https://ganzhiyu.oss-cn-hangzhou.aliyuncs.com/pdf/%E4%B8%AD%E5%8D%8E%E5%8C%BB%E5%AD%A6%E4%BC%9A%E7%AC%AC%E4%B8%80%E6%AC%A1%E7%BB%86%E8%8F%8C%E7%9C%9F%E8%8F%8C%E6%84%9F%E6%9F%93%E5%AD%A6%E6%9C%AF%E4%BC%9A%E8%AE%AE%E6%97%A5%E7%A8%8B.pdf"
				target="_blank">
				<P class="huiyi">大会日程</P>
			</a>

			<a style="text-decoration: none;"
				href="https://ganzhiyu.oss-cn-hangzhou.aliyuncs.com/pdf/bisc2021-Enterprise-participation.pdf"
				target="_blank">
				<P class="huiyi">企业参会通知</P>
			</a>
			<a style="text-decoration: none;"
				href="https://ganzhiyu.oss-cn-hangzhou.aliyuncs.com/pdf/%E4%BC%81%E4%B8%9A%E5%9B%A2%E9%98%9F%E6%B3%A8%E5%86%8C%E4%BF%A1%E6%81%AF%E6%94%B6%E9%9B%86%E8%A1%A8.xlsx"
				target="_blank">
				<P class="huiyi">企业团队注册信息收集表</P>
			</a>

			<a style="text-decoration: none;"
				href="https://ganzhiyu.oss-cn-hangzhou.aliyuncs.com/pdf/%E5%A7%94%E5%91%98%E6%8E%A8%E8%8D%90%E5%9B%A2%E9%98%9F%E6%B3%A8%E5%86%8C%E4%BF%A1%E6%81%AF%E6%94%B6%E9%9B%86%E8%A1%A8.xlsx"
				target="_blank">
				<P class="huiyi">委员推荐团队注册信息收集表</P>
			</a>

			<!-- <a style="text-decoration: none;"
				href="https://ganzhiyu.oss-cn-hangzhou.aliyuncs.com/pdf/%E6%84%9F%E6%9F%93%E5%8C%96%E7%96%97%E4%BC%9A%E8%AE%AE%E6%97%A5%E7%A8%8B.pdf"
				target="_blank">
				<P class="huiyi">感染化疗会议日程PDF下载</P>
			</a>

			<a style="text-decoration: none;"
				href="https://ganzhiyu.oss-cn-hangzhou.aliyuncs.com/pdf/%E4%BA%8C%E8%BD%AE%E9%80%9A%E7%9F%A5-BISC2021.pdf"
				target="_blank">
				<P class="huiyi">会议通知（第二轮）PDF</P>
			</a> -->

			<a style="text-decoration: none;" @click="toWonderful">
				<P class="huiyi">精彩瞬间</P>
			</a>

			<a style="text-decoration: none;" href="https://mp.weixin.qq.com/s/4XnbmZL3iWkjpI6dVeH-Gw" target="_blank">
				<P class="huiyi">学分说明</P>
			</a>

			<titlecom :title="link"></titlecom>

			<el-row style="width: 100%;">
				<el-col :span="7">
					<a href="https://idac2021.sciconf.cn/cn/web/index/" target="_blank" style="text-decoration: none;">
						<div style="width: 150px;text-align: center;cursor: pointer;margin-left: 20px;">
							<img src="../../assets/11.png" style="width: 100%;box-shadow: 0 0 5px rgba(0,0,0,0.1);">
							<div style="color: #666;font-size: 14px;">抗微生物化疗学术会议</div>
						</div>
					</a>
				</el-col>
				<el-col :span="7">
					<a href="https://www.cma.org.cn/" target="_blank" style="text-decoration: none;">
						<div style="width: 150px;text-align: center;cursor: pointer;margin-left: 20px;">
							<img src="../../assets/lianjie.png"
								style="width: 100%;box-shadow: 0 0 5px rgba(0,0,0,0.1);">
							<div style="color: #666;font-size: 14px;">中华医学会</div>
						</div>
					</a>
				</el-col>
				<el-col :span="7">
					<!-- <div style="width: 150px;text-align: center;cursor: pointer;margin-left: 20px;" @click="code">
						<img src="../../assets/homePage/logo1.jpg"
							style="width: 100%;height: 48px;box-shadow: 0 0 5px rgba(0,0,0,0.1);">
						<div style="color: #666;font-size: 14px;">感知域官方公众号</div>
					</div> -->
				</el-col>
				<!-- <el-col :span="7">
			<a href="  " target="_blank" style="text-decoration: none;">
			  <div style="width: 150px;text-align: center;cursor: pointer;margin-left: 20px;">
				<img src="../../assets/homePage/3.jpg" style="width: 100%;box-shadow: 0 0 5px rgba(0,0,0,0.1);">
				<div style="color: #666;font-size: 14px;">抗微生物化疗学术会议</div>
			  </div>
			</a>
		</el-col> -->
			</el-row>

		</div>
		<!-- 		<titlecom :title="exhibition"></titlecom> -->


		<!-- 点击弹出公众号二维码 -->
		<div class="perceptual-box" v-show="isshow" @click="iscode">
			<div class="perceptual-son">
				<img src="../../assets/homePage/gzy.jpg" class="code" />
				<div style="text-align: center;color: #666;font-size: 18px;">扫码关注</div>
			</div>
		</div>


		<!-- 弹出延迟大会框 -->
		<div class="delay" v-if="isdelay" @click="isdelay_btn" style="display: none;">
			<div class="delay_box">
				<div class="delay_son">
					<div class="notice">中华医学会第一次全国细菌真菌感染学术会议 延期通知</div>
					<span
						style="margin-left: 32px;">为贯彻常态化防控精神，</span>中华医学会细菌感染与耐药防治分会主办的“中华医学会第一次全国细菌真菌感染学术会议”，延期至2021年4月8-10日举办，地点仍为上海跨国采购会展中心。非常感谢您对“中华医学会第一次全国细菌真菌感染学术会议”的关注和支持！对会议延期造成的不便，我们深表歉意。
					<div><span
							style="margin-left: 32px;">有关</span>会议日程、具体参会信息及其他更新信息，敬请关注会议官方网站http://bisc2021.ganzhiyu.com/及微官网
					</div>
					<div style="text-align: right;margin-top: 15px;font-size: 18px;line-height: 25px;">
						中华医学会第一次全国细菌真菌感染学术会议会务组
					</div>
					<div style="text-align: right;font-size: 18px;line-height: 30px;">2020.12.01</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import titlecom from "@/components/title/title.vue";


	export default {
		data() {
			return {
				isshow: false,
				isdelay: true,
				title: '会议信息',
				dynamic: '会议动态',
				link: '友情链接',
				exhibition: '参展企业',
				rotationImgList: [{
						url: require("@/assets/lunbo/2.jpg"),
						id: 1
					}
					// {
					// 	url: require("@/assets/lunbo/1.jpg"),
					// 	id: 2
					// },
					// {
					// 	url: require("@/assets/lunbo/1.jpg"),
					// 	id: 3
					// }
				],


			}
		},
		methods: {
			toWonderful() {
				this.$router.push({
					path: '/wonderful'
				})
			},
			code: function() {
				this.isshow = true;

			},
			iscode: function() {
				this.isshow = false;
			},
			schedule: function() {
				this.$router.push({
					path: '/download',
				})
			},
			isdelay_btn: function() {
				this.isdelay = false
				// localStorage.setItem('isdelay',true);
				sessionStorage.setItem('isdelay', true)
			},
			panduan: function() {
				if (sessionStorage.getItem('isdelay')) {
					this.isdelay = false
				} else {
					this.isdelay = true
				}
			}

		},
		components: {
			titlecom
		},
		mounted() {
			this.panduan();
		}
	}
</script>

<style scoped>
	.el-carousel__item h3 {
		color: #475669;
		font-size: 18px;
		opacity: 0.75;
		line-height: 300px;
		margin: 0;
	}

	.el-carousel__item:nth-child(2n) {
		background-color: #99a9bf;
	}

	.el-carousel__item:nth-child(2n+1) {
		background-color: #d3dce6;
	}

	.text {
		line-height: 28px;
		text-indent: 30px;
		color: #666;
		font-size: 16px;
	}

	.title {
		color: rgb(20, 90, 245);
		font-size: 18px;
	}

	.huiyi {
		font-size: 16px;
		color: red;
		margin: 5px 0;
		margin-left: 20px;
		cursor: pointer;
	}

	.huiyi:hover {
		color: #b80000;
	}

	.perceptual-box {
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.3);
		position: fixed;
		top: 0;
		left: 0;
		z-index: 999;

	}

	.perceptual-son {
		width: 300px;
		height: 315px;
		background-color: #fff;
		margin-left: 50%;
		transform: translateX(-50%);
		margin-top: 200px;
	}

	.code {
		margin-left: 50%;
		transform: translateX(-50%);
		margin-top: 10px;
	}

	.delay {
		width: 100%;
		height: 100%;
		position: fixed;
		background-color: rgba(0, 0, 0, 0.5);
		top: 0;
		left: 0;
		z-index: 999;
	}

	.delay_box {
		width: 565px;
		background-color: #fff;
		margin: 0 auto;
		margin-top: 250px;
		border-radius: 5px;
		padding: 20px;
		font-size: 18px;
		color: #555;
		line-height: 32px;
		overflow: hidden;
	}

	.delay_son {
		/* margin-top: 10px; */
	}

	.notice {
		padding: 0;
		text-align: center;
		font-size: 22px;
		margin-bottom: 5px;
		font-weight: bold;
		color: #333;
	}
</style>
